// @flow
import React from 'react';
import { compose, pure } from 'recompose';
import { hot } from 'react-hot-loader';
import { Panel, ButtonToolbar, Button } from 'angieslist-react-components';
import './AddressDisplayCard.scss';

type Props = {
  addresses: Object,
};

const AddressDisplayCard = ({ addresses }: Props) => (
  <div>
    {
      addresses.sort((a, b) => b.isPrimary - a.isPrimary).map(address => (
        <div key={address.id}>
          <Panel className="address-display-card" key={address.id} header={address.isPrimary ? 'Primary Address' : ''}>
            <If condition={address.isPrimary}>
              <p>Maybe some copy about what primary address is and how it impacts the profile.</p>
            </If>
            <div>
              <div>{address.addressFirstLine}</div>
              <div>{address.city.name}, {address.region.abbreviation} {address.postalCode}</div>
            </div>
            <div style={{ marginTop: '1em', textTransform: 'capitalize' }}>
              <strong>Type: </strong>{address.addressType}
            </div>
            <ButtonToolbar style={{ marginTop: '1em' }}>
              <Button
                id={`addresses--edit-${address.id}`}
                bsStyle="primary-office"
                style={{ marginTop: 1, height: 45 }}
                flat
              >
                <i className="icon icon-pencil" /> Edit&nbsp;&nbsp;
              </Button>
              <If condition={!address.isPrimary}>
                <Button id={`addresses--make-primary-${address.id}`} bsStyle="primary-office" flat>
                  Make Primary
                </Button>
                <Button id={`addresses--delete-${address.id}`} bsStyle="danger" flat>
                  <i className="icon icon-cancel-circled" /> Delete
                </Button>
              </If>
            </ButtonToolbar>
          </Panel>
        </div>
      ))
    }
  </div>
);

export default (hot(module)(compose(pure)(AddressDisplayCard)): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/AddressDisplayCard.js